import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { RootState } from "../../rootReducer";
import axiosInstance from "../../../utils/axiosConfig";

const sendDataMiDt = createAsyncThunk(
  "fichaMiDt/sendDataMiDt",
  async (params, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { data } = await axiosInstance.post(`${api.baseURL}contract/midt-register`, {
        contract: state.fichaMiDt.result.contract,
        ficha: state.fichaMiDt.ficha,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default sendDataMiDt;
